import { render, staticRenderFns } from "./UpsellItemForm.vue?vue&type=template&id=1b363dec&scoped=true&"
import script from "./UpsellItemForm.vue?vue&type=script&lang=js&"
export * from "./UpsellItemForm.vue?vue&type=script&lang=js&"
import style0 from "./UpsellItemForm.vue?vue&type=style&index=0&id=1b363dec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b363dec",
  null
  
)

export default component.exports